import Documents from './Documents.view';

export default Documents;
